import React from "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";
import Aviator from "aviator";
import { withLDConsumer } from "launchdarkly-react-client-sdk";

import getBaseUri, { dineInQueryString, isDineInUri } from "get_base_uri";

import Header from "components/header";
import Loader from "components/loader";

import CustomerInfoContainer from "containers/account/customer_info_container";
import OrderHistoryContainer from "containers/account/order_history_container";
import CreditCardListContainer from "containers/account/credit_card_list_container";
import AddressesContainer from "containers/account/addresses_container";
import { isEmpty } from "ramda";

function Account({ request, store, flags }) {
  if (!store?.getState() || isEmpty(flags)) {
    return (
      <div className="app account">
        <Loader />
      </div>
    );
  }
  const state = store.getState();
  document.title = state.storeInfo.locationName;

  return (
    <Provider store={store}>
      <div className="app account">
        <Header
          locationInfo={state.storeInfo}
          onHeadingClick={() =>
            Aviator.navigate(`${getBaseUri(request)}${dineInQueryString()}`)}
        />

        <a
          className="back-button navigate"
          href={`${getBaseUri(request)}${dineInQueryString()}`}>
          &lt; Back to your order
        </a>
        <div className="content">
          <div className="account-settings card main-view">
            <CustomerInfoContainer saveOnBlur />
            <AddressesContainer />
            <CreditCardListContainer />
            {!isDineInUri() && <OrderHistoryContainer />}
          </div>
        </div>
      </div>
    </Provider>
  );
}

Account.propTypes = {
  flags: PropTypes.object,
  request: PropTypes.object.isRequired,
  store: PropTypes.object,
};

export default withLDConsumer()(Account);
